import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/component-custom-slot',
            name: 'admin-component-custom-slot',
            component: () => import(/* webpackChunkName: "page-admin-default-component-custom-slot" */ `./index.vue`),
            meta: {
                data_for_admin_layout: {
                    data_for_history_tag: {
                        entity: {
                            name: "主页"
                        }
                    },
                    data_for_breadcrumb: {
                        entity_list: [
                            {
                                name: "示例功能"
                            },
                            {
                                name: "主页"
                            }
                        ]
                    }
                }
            },

        },
    ],
};
